import React from 'react';
import { useContext } from 'react';

import { AuthContext } from '@shared/context/AuthContext';
import { Navigate, Route, Routes, useLocation, useMatch } from 'react-router-dom';
import { LoginContainer } from '../component/login/loginContainer';
import { useLocalStorage } from '@shared/auth/useLocalStorage';

export const LandingContainer = () => {
    const { user } = useContext(AuthContext);
    const { getStorageItem } = useLocalStorage();
    const location = useLocation();
    return !getStorageItem('user') ? (
        <Routes>
            <Route path={`/`} element={<LoginContainer />} />
        </Routes>
    ) : (
        <Navigate to={location.state && location.state.from ? location.state.from : '/home/dashboard'} />
    );
};
